module.exports = __webpack_public_path__ + "static/jermlaine-d153beba7294f9341f168ca80c036d8e.jpeg";